/**
 * Wallet icons as inline SVG strings
 * Monochrome outlined style - uses currentColor for easy theming
 */

export const walletIcons = {
  metamask: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20L7 16L4 4L10 10H14L20 4L17 16L12 20Z"/></svg>`,

  rainbow: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M4 18A8 8 0 0 1 20 18"/><path d="M7 18A5 5 0 0 1 17 18"/><path d="M10 18A2 2 0 0 1 14 18"/></svg>`,

  rabby: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="15" rx="6" ry="5"/><path d="M8 10C8 10 7 3 9 3C11 3 10 8 10 10"/><path d="M16 10C16 10 17 3 15 3C13 3 14 8 14 10"/></svg>`,

  phantom: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 11C6 6.58 8.69 3 12 3C15.31 3 18 6.58 18 11V19C18 19 17 18 16 19C15 20 14 19 13 19C12 19 12 20 11 19C10 19 9 20 8 19C7 18 6 19 6 19V11Z"/></svg>`
};

export default walletIcons;
